
<template>
  <div class="rightContent">
    <!-- 公司相册 -->
    <template v-if="companyTabIndex===3">
      <div class="header">
        <div class="title f_16 color_40 font_w_b">公司相册</div>
        <div class="tips f_12 color_60">公司照片建议选择近景前台或者其他办公环境，远景门口或者大楼</div>
      </div>
      <div class="intro_picture clearfix">
        <div class="item pr fl" v-for="(item,index) in company_data.intro_picture" :key="index">
          <img :src="`${item}?x-oss-process=image/resize,w_200`" alt="">
          <div class="pa iconfont iconguanbi color_cf cursor_p" @click.stop="pictureIndex=index;MessageBoxState=true"></div>
        </div>
        <div class="addButton fl f_12 color_9c cursor_p pr" v-if="company_data.intro_picture.length<6">
          <p><span class="iconfont iconjia2"></span> 添加公司照片</p>
          <p>图片大小不超过4M</p>
          <input type="file" class="uploader pa cursor_p" ref="fileUpload" accept="image/*" @change="fileUpload">
        </div>
      </div>
      <!-- 显示裁剪图片弹窗 -->
      <div class="checkPicture" v-if="addPictureState">
        <div class="content pa bg_fff">
          <vue-cropper style="background: transparent" ref="cropper" :img="option.img" :canMove="option.canMove" :autoCrop="option.autoCrop" :centerBox="option.centerBox" :fixed="option.fixed" :full="true" :fixedNumber="option.fixedNumber" />
          <div class="templateButtons text_center">
            <div class="button cancelButton" @click="clearPicture">取消</div>
            <div class="button confirmButton" @click="savePicture"><span class="el-icon-loading" v-if="saveFormState"></span> 确定</div>
          </div>
        </div>
      </div>
      <!-- 询问框 -->
      <MessageBox :pageData="MessageBoxData" v-if="MessageBoxState" @confirmButton="confirmButton" @cancelButton="cancelButton" />

    </template>
    


  </div>
</template>

<script>
  const oss = require('ali-oss');
  import { uuid } from 'vue-uuid';
  let { VueCropper } = require('vue-cropper')

  // 所有接口
  import actions from '@/actions/index'
  import { mapState, mapMutations } from 'vuex'
  import company_options from '@/utils/company_options'
  import { dataURLtoBlob, blobToFile } from '@/utils/utils'
  import MessageBox from '@/components/block/MessageBox'
  
  export default {
    name: 'companyRightContent3',
    props: {},
    data() {
      return {
        company_data:{
          intro_picture:[],
        },
        option: {
          img: '', //上传图片bease64
          canMove: true,
          autoCrop: true,
          centerBox: true,
          fixed: true,
          fixedNumber: [16, 9]
        },
        addPictureState:false,
        saveFormState:false, //是否正在保存
        fileType:'', //上传图片类型

        MessageBoxState:false,//是否显示删除框
        MessageBoxData:{
          title:'温馨提示',
          desc:'确定删除这个公司相册吗？'
        },
        pictureIndex:-1, //编辑的第几个
        logoUrl:'https://logo.wondercv.com',//logo域名
        
      }
    },
    created() {
      // this.logoUrl = process.env.VUE_APP_ENV_TYPE === 'prod' ? 'https://logo.wondercv.com' : 'https://logo.wondercv.cn';
    },
    computed: {
      ...mapState('block', ['ossOptions']),
      ...mapState('company', ['companyData', 'companyTabIndex']),
    },
    components: {
      VueCropper,
      MessageBox
    },
    methods: {
      ...mapMutations('company',['updateCompanyData','updateCompanyTabIndex']),
      //上传之前验证
      beforeFileUpload(file) {
        const fileTypes = 'image/png,image/gif,image/jpeg,image/tif,image/tiff,image/bmp,image/x-bmp'
        const isJPG = fileTypes.indexOf(file.type)>-1;
        const isLt2M = file.size / 1024 / 1024 < 4;
        if (!isJPG) {
          this.$message.error('上传公司相册格式错误!');
          return false;
        }
        if (!isLt2M) {
          this.$message.error('上传公司相册大小不能超过 4MB!');
          return false;
        }
        return true;
      },
      //图片上传
      fileUpload(e){
        // 获取图片base64
        let file = this.$refs.fileUpload.files[0];
        if(!this.beforeFileUpload(file)){
          this.$refs.fileUpload.value = '';
          return false;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e =>{
          var image = new Image();
          image.src = e.currentTarget.result;
          image.onload = ()=>{
            if(image.width<300 || image.height<170){
              this.$message.error('图片尺寸过小，建议重新上传');
              this.$refs.fileUpload.value = '';
              return false;
            }
            //拿到图片的款高
            this.option.img = e.currentTarget.result;
            this.fileType = file.type.split('/')[1];
            this.addPictureState = true;
            document.body.style.position = 'static'
            document.body.style.overflow = 'hidden'
          };
        }
      },
      //上传图片
      savePicture () {
        if(this.saveFormState){
          return false;
        }
        this.$refs.cropper.getCropData(async file => {
          this.saveFormState = true;
          let downloadLoading =  this.$message({
            message: '正在上传',
            iconClass:'el-icon-loading',
            duration:0,
          });
          const store = oss(this.ossOptions);
          let imgName = `${uuid.v1()}.${this.fileType}`
          //调用
          var blob = dataURLtoBlob(file);
          var fileData = blobToFile(blob, imgName);
          store.put(`company_intro/${imgName}`, fileData).then((res) => {
            downloadLoading.close();
            if(res.res.statusCode===200){
              this.company_data.intro_picture.push(`${this.logoUrl}/${res.name}`);
              // this.$message({
              //   message: '上传成功',
              //   type: 'success'
              // });
              //上传相册
              this.saveForm();
            }else{
              this.saveFormState = false;
              this.$message({
                message: '图片上传失败',
                type: 'error'
              });
            }
          });
        
        })
      },
      //取消上传
      clearPicture(){
        if(this.saveFormState){
          return false;
        }
        this.addPictureState = false;
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
        this.$refs.fileUpload.value = '';
        this.option.img = ''
      },
      //保存图片
      saveForm(type){
        let { intro_picture } = this.company_data;
        let data = {
          intro_picture
        }
        actions.company.put_company_companies(this.company_data.token,data).then(res=>{
          this.saveFormState = false;
          if(res.code === 1000){
            let companyData = JSON.parse(JSON.stringify(this.companyData));
            companyData.intro_picture = intro_picture;
            //同步数据到vuex
            this.updateCompanyData(companyData)
            //关闭上传
            this.clearPicture();
            if(type==='delete'){
              this.$message.success('公司相册删除成功')
            //关闭确认
            this.MessageBoxState = false;
            }else{
              this.$message.success('公司相册上传成功')
            }
          }else{
            this.$message({
              message:res.message,
              type:'error'
            })
          }
        })
      },
      //【删除】执行确认
      confirmButton(){
        this.company_data.intro_picture.splice(this.pictureIndex,1);
        this.saveForm('delete');
      },
      //【删除】执行取消
      cancelButton(){
        this.MessageBoxState = false;
      },
    },
    watch:{
      companyData :{
        handler: function (val, oldVal) {
          this.company_data = JSON.parse(JSON.stringify(val));
        },
        deep: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './rightContent.scss';
</style>